import { Button, Paper, Stack, Text } from '@mantine/core';
import { useSetLastContact, type Lead } from '@/models/leads';

type Props = {
  lead: Lead;
  canConvert: boolean;
  isConvertible: boolean;
  onConvert: () => void;
};

export function ActionsCard({
  lead,
  canConvert,
  isConvertible,
  onConvert,
}: Props) {
  const markContacted = useSetLastContact();

  return (
    <Paper withBorder p="sm">
      <Stack gap="xs">
        {canConvert && isConvertible && (
          <Button size="xs" color="blue" onClick={onConvert}>
            Convert to contact
          </Button>
        )}
        <Button
          size="xs"
          variant="default"
          loading={markContacted.isPending}
          onClick={() => markContacted.mutate({ leadId: lead.id })}
        >
          Mark contacted now
        </Button>
        <Text size="xs" c="dimmed">
          Last contact:{' '}
          {lead.lastContactAt
            ? new Date(lead.lastContactAt).toLocaleString()
            : 'Never'}
        </Text>
      </Stack>
    </Paper>
  );
}
